/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ViewMenu } from '../../models/view-menu';

export interface ApiMasterMenuGetMenuViewGet$Params {
}

export function apiMasterMenuGetMenuViewGet(http: HttpClient, rootUrl: string, params?: ApiMasterMenuGetMenuViewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ViewMenu>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterMenuGetMenuViewGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ViewMenu>>;
    })
  );
}

apiMasterMenuGetMenuViewGet.PATH = '/api/Master/Menu/GetMenuView';
